<template>
  <div>
    <b-modal
      hide-footer
      size="md"
      title="Short Term Block"
      centered
      id="short-term-block-modal"
      @hidden="hideModal"
    >
      <div class="text-center">
        <h3 class="font-weight-bold">Short Term Block</h3>
      </div>
      <p class="text-center font-weight-bold text-black">
        Short Term block can be between 1 day and 6 weeks.
      </p>

      <!-- Description text -->
      <p class="text-center text-black">With a short break, please note:</p>

      <!-- Bullet list -->
      <ul class="text-black">
        <li>
          You will be logged out and won’t be able to log into your account
        </li>
        <li>
          All pending bets will remain in your account. If you would like to
          withdraw funds, you can contact customer support
        </li>
        <li>
          You still stop receiving marketing material for the duration of your
          break (taking effect within 24 hours)
        </li>
        <li>You will be able to log in after your break is completed</li>
        <li>The break will take effect immediately</li>
      </ul>

      <!-- Form -->
      <b-form-group label="Start Date" class="text-black">
        <flat-pickr v-model="form.startDate" :config="configDateFrom" />
      </b-form-group>

      <b-form-group label="End Date" class="text-black">
        <flat-pickr v-model="form.endDate" :config="configDateTo" />
      </b-form-group>

      <b-form-group label="Comments" class="text-black">
        <b-form-input
          v-model="form.comments"
          placeholder="Comments"
        ></b-form-input>
      </b-form-group>

      <!-- Buttons -->
      <b-button
        block
        variant="danger"
        class="mt-2"
        :disabled="loadingClientProfile"
        @click="handleSubmit"
      >
        SET SHORT TERM BLOCK
      </b-button>

      <b-button block @click="hideModal"> CANCEL </b-button>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BFormGroup, BFormInput, BButton } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";
import { formatDateSend } from "@/helpers/utils";
import { addDays } from "date-fns";
export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BButton,
    flatPickr,
  },
  data() {
    return {
      form: {
        startDate: "",
        endDate: "",
        comments: "",
      },
      configDateFrom: {
        enableTime: true,
        altFormat: "Y-m-d H:i:ss",
        enableSeconds: true,
        altInput: true,
        static: true,
        minDate: new Date(),
      },
      configDateTo: {
        enableTime: true,
        altFormat: "Y-m-d H:i:ss",
        enableSeconds: true,
        altInput: true,
        static: true,
      },
    };
  },
  watch: {
    "form.startDate"(newVal) {
      this.configDateTo = {
        ...this.configDateTo,
        minDate: addDays(new Date(newVal), 1),
        maxDate: addDays(new Date(newVal), 42),
      };
    },
  },
  computed: {
    ...mapState("user/detail", ["loadingClientProfile"]),
  },
  methods: {
    ...mapActions({
      updateClientProfile: "user/detail/updateClientProfile",
      fetchUser: "user/detail/asyncUser",
    }),
    formatDateSend,
    async handleSubmit() {
      const payload = {
        userId: this.$route.params.id,
        breakStartDate: new Date(this.form.startDate).toISOString(),
        breakTime: new Date(this.form.endDate).toISOString(),
        reasonUpdate: this.form.comments,
      };
      const result = await this.updateClientProfile(payload);
      if (result) {
        this.showToastSuccess("Short Term Break successfully!");
        this.hideModal();
        this.fetchUser({ id: this.$router.currentRoute.params.id });
      }
    },
    hideModal() {
      this.form = {
        startDate: "",
        endDate: "",
        comments: "",
      };
      this.$bvModal.hide("short-term-block-modal");
    },
  },
  setup() {
    const { showToastSuccess, showToastError } = useToastHandler();
    return {
      showToastSuccess,
      showToastError,
    };
  },
};
</script>

